<template>
    <div id="FormAdd">
        <div class="header">
            <div class="icon-container">
                <i class="md-icon">code</i>
            </div>
            <div class="text-container">
                <div class="title">EKLE</div>
                <div class="description">Bu pasajı kopyalayıp kodunuza yapıştırın ve formunuzu web sitenize
                    yerleştirin.
                </div>
            </div>
        </div>
        <div class="card-iframe" @click="toggleExpand">
            <div class="icon-section">
                <i class="md-icon">view_in_ar</i>
            </div>
            <div class="text-section">
                <div class="title">IFRAME</div>
                <div class="description">Formunu sayfanıza iFrame ile ekleyin</div>
            </div>
            <div class="arrow-section">
                <i class="md-icon">chevron_right</i>
            </div>
        </div>
        <div v-if="expanded" class="code-section">
            <pre>{{ iframeCode }}</pre>
            <button @click="copyCode">Kopyala</button>
        </div>
        <div class="card-pop-up" @click="openPopUp">
            <div class="icon-section">
                <i class="md-icon">open_in_new</i>
            </div>
            <div class="text-section">
                <div class="title">AÇILIR PENCERE</div>
                <div class="description">Bir açılır pencere formuna bağlantı verin</div>
            </div>
            <div class="arrow-section">
                <i class="md-icon">chevron_right</i>
            </div>
        </div>
        <div v-if="popup" class="code-section">
            <pre>{{ popUpCode }}</pre>
            <button @click="copyPopUp">Kopyala</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormAdd",
    props: {
        formId: {
            type: String,
            required: true,
        },
        siteId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            expanded: false,
            popup: false,
            iframeCode: `<iframe src="https://form.supsis.ai/form/${this.formId}/${this.siteId}" width="600" height="400"></iframe>`,
            popUpCode: `<a href="javascript:void( window.open( 'https://form.supsis.ai/form/${this.formId}/${this.siteId}', 'blank', 'scrollbars=yes, toolbar=no, width=700, height=500' ) )"> Form </a>`,
        };
    },
    methods: {
        toggleExpand() {
            this.expanded = !this.expanded;
            this.popup = false;
        },
        openPopUp() {
            this.popup = !this.popup;
            this.expanded = false;
        },
        copyCode() {
            navigator.clipboard.writeText(this.iframeCode).then(() => {
                this.$message.success("Kod kopyalandı!");
            });
        },
        copyPopUp() {
            navigator.clipboard.writeText(this.popUpCode).then(() => {
                this.$message.success("Kod kopyalandı!");
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#FormAdd {
    display: grid;
    justify-content: center;
    padding: 2rem;
    font-family: 'Roboto', sans-serif;

    .header {
        display: flex;
        align-items: center;
        background-color: #f7f7f7;
        padding: 1rem;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin-bottom: 1.5rem;
        width: 700px;

        .icon-container {
            background-color: #4d4f97;
            border-radius: 8px;
            padding: 0.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;

            i {
                color: #fff;
                font-size: 2rem;
            }
        }

        .text-container {
            .title {
                font-weight: bold;
                font-size: 1.5rem;
                color: #002855;
            }

            .description {
                font-size: 1rem;
                color: #666;
            }
        }
    }

    .card-iframe {
        display: flex;
        align-items: center;
        background-color: #f7f7f7;
        border: 1px solid #dcdcdc;
        border-radius: 8px;
        padding: 1rem;
        width: 100%;
        max-width: 700px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.3s;
        border-left: 5px solid #9c27b0;
        cursor: pointer;
        margin-bottom: 10px;

        &:hover {
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        .icon-section {
            background-color: #9c27b0;
            padding: 1rem;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;

            i {
                color: #fff;
                font-size: 2rem;
            }
        }

        .text-section {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .title {
                font-weight: bold;
                font-size: 1.25rem;
                color: #1f224f;
            }

            .description {
                font-size: 1rem;
                color: #666;
            }
        }

        .arrow-section {
            display: flex;
            justify-content: center;
            align-items: center;

            i {
                font-size: 1.5rem;
                color: #666;
            }
        }
    }

    .card-pop-up {
        display: flex;
        align-items: center;
        background-color: #f7f7f7;
        border: 1px solid #dcdcdc;
        border-radius: 8px;
        padding: 1rem;
        width: 100%;
        max-width: 700px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.3s;
        border-left: 5px solid #78bb07;
        cursor: pointer;

        &:hover {
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        .icon-section {
            background-color: #78bb07;
            padding: 1rem;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;

            i {
                color: #fff;
                font-size: 2rem;
            }
        }

        .text-section {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .title {
                font-weight: bold;
                font-size: 1.25rem;
                color: #1f224f;
            }

            .description {
                font-size: 1rem;
                color: #666;
            }
        }

        .arrow-section {
            display: flex;
            justify-content: center;
            align-items: center;

            i {
                font-size: 1.5rem;
                color: #666;
            }
        }
    }

    .code-section {
        margin-top: 0.5rem;
        margin-bottom: 10px;
        background-color: #f7f7f7;
        padding: 1rem;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        width: 100%;
        max-width: 700px;

        pre {
            background-color: #e0e0e0;
            padding: 1rem;
            border-radius: 4px;
            overflow-x: auto;
            margin-bottom: 1rem;
        }

        button {
            background-color: #1976d2;
            color: white;
            border: none;
            padding: 0.5rem 1rem;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.3s;

            &:hover {
                background-color: #1565c0;
            }
        }
    }
}
</style>
